import $ from 'jquery';
export default class ContrastSwitch {
    static mount() {
        $(function () {
            new ContrastSwitch();
        });
    }
    constructor() {
        const $buttons = $('.ce-contrast-button');
        $buttons.on('click', () => {
            $('body').toggleClass('contract-modus');
        });
    }
}
